exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-termsOfService-3M4bs{color:var(--color-night-gray9,#2c3652);margin-top:24px;font-family:Roboto;font-size:14px;font-style:normal}.style-cssmodule-termsOfService-3M4bs h5{font-size:14px!important;font-weight:700;line-height:22px;letter-spacing:.14px;text-decoration-line:underline;text-decoration-style:solid;text-decoration-skip-ink:auto;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font}", ""]);

// exports
exports.locals = {
	"termsOfService": "style-cssmodule-termsOfService-3M4bs"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/templates/AuthenticationLayout/components/ModalTermsOfService/style.cssmodule.css
// module id = 2542
// module chunks = 121